import {webClient} from "../../config/axios";
import {handleError} from "../handleRequestError";

export const compareStationsDataRequest = (body,callback) => {
    webClient.post('/compare/stations-data', body, {
        headers: {
            "Content-Type": "application/json"
        },
        timeout: 0
    })
        .then(response => {
            callback(response.data, false);
        })
        .catch(err => {
            handleError(err, callback);
        })
};
